import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: true,
        resources: {
            en: {
                common: {
                    English: 'English',
                    Vietnamese: 'Vietnamese'
                },
                ContestantList: {
                    'Contestant List': 'Top 24 Semifinalists',
                    'Search by name': 'Search by name',
                    'No contestants found': 'No contestants found',
                    'Loading data': 'Loading data'
                },
                ContestantDetails: {
                    'Go back': 'Go back',
                    "I'm from": "I'm from",
                    'and I was born in': 'and I was born in',
                    Share: 'Share',
                    Preview: 'Preview'
                },
                Navbar: {
                    Home: 'Home',
                    Contestants: 'Contestants',
                    Navigation: 'Navigation'
                }
            },
            vi: {
                common: {
                    English: 'Tiếng Anh',
                    Vietnamese: 'Tiếng Việt'
                },
                ContestantList: {
                    'Contestant List': 'Top 24 thí sinh bán kết',
                    'Search by name': 'Tìm kiếm theo tên',
                    'Loading data': 'Dữ liệu đang tải',
                    'No contestants found': 'Không tìm thấy thí sinh nào',
                    "That's the end of the list!": 'Bạn đã đến cuối danh sách!',
                    'You just scrolled through': 'Bạn vừa lướt qua',
                    people: 'thí sinh',
                    'Return to top': 'Quay lại đầu trang'
                },
                ContestantDetails: {
                    'Go back': 'Quay lại',
                    "I'm from": 'Mình đến từ',
                    'and I was born in': 'và mình sinh ra năm',
                    Share: 'Chia sẻ',
                    Preview: 'Xem trước',
                    'This contestant does not exist.': 'Thí sinh này không tồn tại.',
                    'Return to list': 'Quay lại danh sách',
                    'Introduction video': 'Video giới thiệu',
                    'Link to Post': 'Link bài viết',
                    Contestant: 'Thí sinh',
                    "Hi, I'm": 'Chào bạn, mình là',
                    'and my ID is': 'và SBD mình là',
                    'Please refresh the page to get new data.': 'Hãy tải lại trang để lấy số liệu mới nhất',
                    Reach: 'Lượt Tiếp cận',
                    Engagement: 'Lượt tương tác'
                },
                Navbar: {
                    Home: 'Trang chủ',
                    Contestants: 'Thí sinh',
                    Navigation: 'Điều hướng'
                }
            }
        },
        interpolation: {
            escapeValue: false
        }
    })

export default i18n
